import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
export function _executeApi(apiLink, credentials, getToken, commit, callback) {
    try {
        // console.log('execute apiLink=====>',apiLink)
        credentials.localParams.parameter.response_msg = ''
        credentials.localParams.parameter.msg_type = ''
        let response_array = [];
        //==================================================================

        if (getToken == '') { getToken = '' }
        //=================================================================
        if (credentials.localParams.type == 'form') { credentials.globalParams = credentials.globalParams.form }
        if (credentials.localParams.module == 'ticket-reply') { credentials.globalParams = credentials.globalParams.form }

        if (credentials.localParams.loaderFuncRun && credentials.localParams.loaderFuncRun == '0') {
            credentials.localParams.parameter.pageLoader = false
        }
        // else if(credentials.localParams.tick_id){
        //     credentials.localParams.parameter.pageLoader = false
        //     credentials.localParams.parameter.type_ticket_detail = true
        // }
        else if (credentials.localParams.page == 'man_account') {
            credentials.localParams.parameter.pageLoader = false
            credentials.localParams.parameter.depositAddLoader = true
        } else {
            credentials.localParams.parameter.pageLoader = true
        }

        RxFactory.post(Enpoints.GLOBAL_BASE_URL + apiLink, credentials.globalParams, getToken)
            // console.log(Enpoints.GLOBAL_BASE_URL, ">>>>>>>>>>>>>>>>>>")
            .map(response => response.data)
            .subscribe(data => {
                //console.log('credentials.localParams.page===',credentials.localParams.page)
                if (credentials.localParams.page == 'man_account') {
                    //console.log('iffffffff')
                    credentials.localParams.parameter.depositAddLoader = false
                } else {
                    // console.log('elseee')
                    credentials.localParams.parameter.pageLoader = false
                }
                localStorage.setItem('unauthFlag', '')
                if ('info' in data) {
                    if (data.info === 'OK') {
                        response_array.res_data = data.data
                        response_array.data = data
                        callback(false, response_array)
                    } else {
                        if (data.msg.code && data.msg.code.toUpperCase() == 'BACK_MSG') {
                            response_array.res_data = 'BME' + data.msg.msg
                        } else if (data.msg.code && data.msg.code.toUpperCase() == 'FILE_UPLOAD') {
                            response_array.res_data = data.msg.msg
                        } else if (data.msg.code && data.msg.code.toUpperCase() == 'OTP_EXPIRED') {
                            response_array.res_data = data.msg.msg
                        } else {
                            response_array.res_data = data.msg.code
                        }

                        response_array.res_msg = data.msg.msg
                        response_array.data = data
                        callback(true, response_array)
                    }
                }
            },
                e => { _handleErrorResponse(e, commit) })
    } catch (ex) { _handleErrorResponse(ex, commit) }
}
export function compare(a, b) {
    if (a.priority < b.priority)
        return -1;
    if (a.priority > b.priority)
        return 1;
    return 0;
}
export function _ticketFunction(respData) {
    // priority basis keys 
    //parent  ['1', '3', '4', '2']
    const getResponseData = respData
    let keyByPriortity = []
    let obj = {}
    let count = 0
    for (var key in getResponseData) {
        const parent_id = getResponseData[key].id
        keyByPriortity[getResponseData[key].priority] = parent_id
        obj["-1"] = keyByPriortity

        let childCount = 0
        count++
        const child = getResponseData[key].categories
        ////console.log(child)
        if (child) {
            let childPriority = []
            for (var i = 0; i <= child.length - 1; i++) {
                const children = child[i]
                childPriority[children.priority] = children.id
                childCount++
                if (i == child.length - 1) {
                    //empty
                    var filtered = childPriority.filter(function (el) {
                        return el != null && el != '';
                    });
                    obj[parent_id] = filtered
                }
                if (i == child.length - 1 && count == Object.keys(getResponseData).length) {
                    var childfiltered = keyByPriortity.filter(function (el) {
                        return el != null && el != '';
                    });
                    obj["-1"] = childfiltered
                    return obj
                }
            }
        } else {
            if (count == Object.keys(getResponseData).length) {
                var childfiltered = keyByPriortity.filter(function (el) {
                    return el != null && el != '';
                });
                obj["-1"] = childfiltered
                return obj;
            }
        }

    }
}
export function _messageDisplayFunction(getParameter, getMessage, msgType) {
    getParameter.response_msg = getMessage
    getParameter.msg_type = msgType
}
export function _handleLogout(data, commit, options, getters) {
    const router = options.router
    let user = {}
    localStorage.removeItem('user');
    localStorage.removeItem('currencyList');
    localStorage.setItem('unauthFlag', false)
    if ('msg' in data && 'info' in data) {
        _cleanUp(commit, data.msg, data.info)
    }
    if (options.forward === true) {
        window.location.replace("/")
    }
}

function _cleanUp(commit, msg, status, loaderId) {
    let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
    commit("SET_TOGGLE_LOADER", loaderArr)
    commit("SET_INFO", msg)
}
function _handleErrorResponse(e, commit) {
    let response = { info: 'NOK', msg: 'Service not available' }
    if (typeof e.response === 'undefined') {
        try {
            const statusCheck = e.toString().toLowerCase()
            if (statusCheck.indexOf('network') > -1) {
                response = { info: 'NOK', msg: 'Network Error' }
            }
        } catch (e) { }
    } else {
        response = e.response.data
    }
    _cleanUp(commit, response, response.status)
    if (typeof e.response !== 'undefined') {
        if (e.response.status == 401) {
            localStorage.removeItem('user');
            localStorage.setItem('unauthFlag', true)
            let data = {}
            let options = {}
            options.forward = true
            _handleLogout(data, commit, options)
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/commomFunction.js